import { useGetCurrentUserQuery } from "@/store/services/supabase";
import { useKeys } from "@/utils/hooks/useKeys";

export const useKeysLocked = (): boolean => {
  const [keyPair] = useKeys();
  const { data: currentUser } = useGetCurrentUserQuery();

  return !keyPair.user || !currentUser || (!!currentUser.has_org_keys && !keyPair.org);
};
